import { render, staticRenderFns } from "./CompanyIBAN.vue?vue&type=template&id=7298ed01"
import script from "./CompanyIBAN.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyIBAN.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports